/* eslint-disable sonarjs/cognitive-complexity */
import * as Sebrae from '@sebrae/react-core';
import { useCallback, useState } from 'react';
import { useJohariController } from '../../../../../hooks/controllers/johari-controller';

const cache = Sebrae.StorageUtil.inTemporaryStore();

export const useStep = () => {
  // const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  const { getJohariDataInterviewPublic, saveJohariAnswer } =
    useJohariController();
  const { getRouteParam, navigateTo } = Sebrae.useRouter();

  const dataQueryString = useCallback(() => {
    const moduleId = getRouteParam('module');
    const cpf = getRouteParam('cpf');

    if (moduleId) {
      cache.setItem(`@empretec:module`, Number(moduleId));
    }

    if (cpf) {
      getJohariDataInterviewPublic(moduleId, Number(cpf))
        .then((response) => {
          console.log(response);
          cache.setItem(`@empretec:interview`, Number(response.id));
          setName(response.candidate.name);
          if (
            !response.isActiveJohari ||
            response.isActiveJohari === undefined
          ) {
            navigateTo('/candidato/questionario/link-expirado');
          }
        })
        .catch((err) => console.log(err));
    }
  }, [getJohariDataInterviewPublic, getRouteParam, navigateTo]);

  const parseData = useCallback((value) => {
    const data = JSON.parse(value);

    const questions = Object.entries(data).map(([id, value]) => {
      return {
        id: Number(id),
        options: [value],
      };
    });

    return questions;
  }, []);

  const save = useCallback(async () => {
    const proximidade = cache.getItem('@empretec:proximidade');
    const avaliacao = cache.getItem('@empretec:avaliação');
    const adjetivos = cache.getItem('@empretec:adjetivos');
    const emailSt = cache.getItem('@empretec:email');

    const interviewId = cache.getItem('@empretec:interview');

    const proximidadeData = parseData(proximidade);
    const avaliacaoData = parseData(avaliacao);
    const adjetivosData = Object.entries(JSON.parse(adjetivos))
      .filter(([key, value]) => value === true)
      .map(([key, value]) => ({
        id: 12,
        options: [parseInt(key)],
      }));

    const questions = [...proximidadeData, ...avaliacaoData, ...adjetivosData];
    const dto = {
      emailCollaborator: emailSt,
      questions,
      idInterview: Number(interviewId),
    };

    try {
      await saveJohariAnswer(dto);
      navigateTo('/candidato/questionario/resultado');
    } catch (error) {
      navigateTo('/candidato/questionario/resultado/falhou');
    }
  }, [navigateTo, parseData, saveJohariAnswer]);

  return {
    name,
    dataQueryString,
    save,
  };
};
